
const maintenance = [
    { label: "Department Work Request", path: '/departmentworkrequest' },
    { label: " Work Order Management", path: '/workorder' },
   ]
  
const options = [
    
    { label: "Change Password", path: '/changepassword' },

]
export {
  
    maintenance,
    options
  
}